/**
 * The legacy loading spinners, moved out of `general/Icons.tsx` so that module
 * could be deleted with the `SvgIcon` registry (Phase 4 of
 * specs/portal-icon-system-consolidation.md). None of them is an icon.
 *
 * Carried across unchanged, including the `variant` props that nothing reads —
 * both render `LoadingPlaceholder` from the design system, which takes no
 * variant. Straightening that out means touching ~40 call sites and is not this
 * phase's job; the replacement to reach for in new code is
 * `<LoadingPlaceholder>` itself.
 */
import { LoadingPlaceholder } from "@indigo-components";
import { FC } from "react";

interface LoadingSpinnerProps {
  width?: number;
  height?: number;
  variant?: "light" | "dark" | "borderless" | "light-disabled";
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  width = 32,
  height = 32,
}) => {
  return (
    <LoadingPlaceholder
      width={width + 8}
      height={height + 8}
      className="mt-2"
    />
  );
};

interface SmallLoadingSpinnerProps {
  variant?: "light" | "dark" | "light-disabled";
}

export const SmallLoadingSpinner: FC<SmallLoadingSpinnerProps> = ({
  variant = "light",
}) => (
  <div className="w-auto h-9 flex items-center justify-center">
    <LoadingSpinner width={16} height={16} variant={variant} />
  </div>
);
